import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom"; 
import CreatePwdForm from "./createPwdForm";

const CreatePassword = (props) => {
    const token = props.match.params.token; 
    const [createPwdSuccess, setCreatePwdSuccess] = useState(false);
    const history = useHistory(); 
    const location = props.match.path.replace(/\/:token$/, ''); 


    useEffect(() => {
        if (createPwdSuccess) {
            history.push("/login"); 
        }
    }, [createPwdSuccess, history]);

    return (
        <div 
            className="login d-flex align-items-center justify-content-center" 
            style={{ background: "linear-gradient(to top, #dfe9f3 0%, white 100%)" }}
        >
            {createPwdSuccess ? null : (
                <CreatePwdForm setCreatePwdSuccess={setCreatePwdSuccess} id={token} location={location} />
            )}
        </div>
    );
};

export default CreatePassword;
